/* DecantGems wishlist. One file, no dependencies. Settings come from snippets/dg-wishlist-boot.liquid (window.DGW).

   Phase 0 (DGW.api empty): the list lives in this browser only (key "dg-wishlist:1": localStorage with consent
                            for preferences, sessionStorage without). Nothing is sent.
   Phase 1 (DGW.api set):   still local first. The list goes to our own worker only after the visitor gave an
                            e-mail address and ticked the box on the wishlist page; from then on changes are synced,
                            until the visitor stops (here or through the link in a mail). If the worker cannot be
                            reached, everything on the page keeps working and the sync is retried later.

   The script never writes a price. Cards on the wishlist page are rendered by Shopify (section dg-wishlist-card). */
(function () {
  'use strict';

  var C = window.DGW;
  if (!C || window.__ngwInit) return;
  window.__ngwInit = 1;

  var KEY = 'dg-wishlist:1';
  var MAX = Math.max(1, Math.min(250, Number(C.max) || 100));
  var SHARE_MAX = 40; /* perfumes in a share link: keeps the address short enough for every messenger */
  var PID = /^[0-9]{5,20}$/;
  var HANDLE = /^[a-z0-9][a-z0-9_-]{0,254}$/;
  var LIST_ID = /^[A-Za-z0-9_-]{20,44}$/;
  var EMAIL = /^[^\s@<>()"',;:\\]+@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i;
  var doc = document;
  var T = C.t || {};
  var API = C.api ? String(C.api).replace(/\/+$/, '') : '';

  function fill(s, vars) {
    return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && k in vars ? vars[k] : m; });
  }

  /* ---------- the list ----------
     { v: 1, i: [[productId, handle, savedAt, gone]], r: revision, id: list key (made only when the visitor opts in),
       on: 0 local only | 1 synced | 2 synced, waiting for the confirmation mail, d: 1 = a change is not at the worker yet,
       cap: the worker's limit of arrival requests per address when this list is over it } */
  var mem = null; /* fallback when storage is not allowed (private window) */
  var lsOk = true;

  function blank() { return { v: 1, i: [], r: 0, id: null, on: 0, d: 0, cap: 0 }; }
  function clean(raw) {
    var out = blank();
    var seen = {};
    if (!raw || typeof raw !== 'object' || !Array.isArray(raw.i)) return out;
    raw.i.forEach(function (x) {
      if (!Array.isArray(x)) return;
      var p = String(x[0]);
      var h = String(x[1] || '').toLowerCase();
      if (!PID.test(p) || !HANDLE.test(h) || seen[p] || out.i.length >= MAX) return;
      seen[p] = 1;
      var t = Math.floor(Number(x[2]));
      out.i.push([p, h, t > 0 ? t : Date.now(), x[3] ? 1 : 0]);
    });
    out.r = Number(raw.r) > 0 ? Math.floor(Number(raw.r)) : 0;
    out.id = typeof raw.id === 'string' && LIST_ID.test(raw.id) ? raw.id : null;
    out.on = out.id && (raw.on === 1 || raw.on === 2) ? raw.on : 0;
    out.d = out.on && raw.d ? 1 : 0;
    out.cap = out.on && Number(raw.cap) > 0 ? Math.floor(Number(raw.cap)) : 0;
    return out;
  }
  /* Theme builder's change to the kit (7 Oct 2026): where the list is kept follows the visitor's cookie choice,
     read from Shopify's customer privacy API, the same gate as the theme's "recently viewed".
     Consent for preferences: localStorage, the list is there on the next visit.
     No consent (declined, or the banner not answered): sessionStorage, hearts work for this visit and nothing
     is kept afterwards. A choice made or changed during the visit moves the list to the right place. */
  var persist = null; /* null = not known yet, true / false = the visitor's choice */

  function load() {
    var raw = null;
    try {
      raw = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (!raw && persist !== false) raw = JSON.parse(window.localStorage.getItem(KEY) || 'null');
    } catch (e) { raw = null; lsOk = false; }
    if (!raw && !lsOk) raw = mem;
    return clean(raw);
  }
  function save(s) {
    mem = s;
    try {
      if (persist === true) window.localStorage.setItem(KEY, JSON.stringify(s));
      else window.sessionStorage.setItem(KEY, JSON.stringify(s));
      lsOk = true;
    } catch (e) { lsOk = false; }
    paint(s);
  }
  function setPersist(yes) {
    yes = !!yes;
    if (persist === yes) return;
    persist = yes;
    try {
      if (yes) {
        var visit = window.sessionStorage.getItem(KEY);
        if (visit) { window.localStorage.setItem(KEY, visit); window.sessionStorage.removeItem(KEY); }
      } else {
        var kept = window.localStorage.getItem(KEY);
        if (kept) {
          if (!window.sessionStorage.getItem(KEY)) window.sessionStorage.setItem(KEY, kept);
          window.localStorage.removeItem(KEY);
        }
      }
    } catch (e) {}
    paint(load());
  }
  function askConsent() {
    var S = window.Shopify;
    function allowed() {
      try { return !!(S.customerPrivacy && S.customerPrivacy.preferencesProcessingAllowed()); } catch (e) { return false; }
    }
    if (S && S.customerPrivacy) { setPersist(allowed()); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { setPersist(!error && allowed()); });
      return;
    }
    setPersist(false);
  }
  doc.addEventListener('visitorConsentCollected', function (e) { setPersist(!!(e.detail && e.detail.preferencesAllowed)); });
  function at(s, pid) {
    for (var k = 0; k < s.i.length; k++) if (s.i[k][0] === pid) return k;
    return -1;
  }
  function visible(s) {
    return s.i.filter(function (x) { return !x[3]; }).sort(function (a, b) { return b[2] - a[2]; });
  }
  function touch(s) {
    s.r += 1;
    if (s.on) s.d = 1;
  }
  /* -> 'added' | 'has' | 'full' | 'bad' */
  function add(s, pid, handle, t) {
    pid = String(pid);
    handle = String(handle || '').toLowerCase();
    if (!PID.test(pid) || !HANDLE.test(handle)) return 'bad';
    var k = at(s, pid);
    if (k >= 0) {
      if (!s.i[k][3]) return 'has';
      s.i[k][3] = 0; /* was hidden as "no longer in the shop": the visitor saved it again */
      s.i[k][1] = handle;
      touch(s);
      return 'added';
    }
    if (s.i.length >= MAX) return 'full';
    s.i.push([pid, handle, t > 0 ? Math.floor(t) : Date.now(), 0]);
    touch(s);
    return 'added';
  }
  function drop(s, pid) {
    var k = at(s, String(pid));
    if (k < 0) return null;
    var it = s.i.splice(k, 1)[0];
    touch(s);
    return it;
  }

  /* ---------- network (XMLHttpRequest: shop apps like to wrap window.fetch) ---------- */
  function xhr(method, url, body, cb) {
    var x;
    try {
      x = new XMLHttpRequest();
      x.open(method, url, true);
      x.timeout = 12000;
      if (body) x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () {
        var j = null;
        try { j = JSON.parse(x.responseText); } catch (e) { j = null; }
        cb(x.status, j, x.responseText, x);
      };
      x.onerror = x.ontimeout = function () { cb(0, null, ''); };
      x.send(body ? JSON.stringify(body) : null);
    } catch (e) {
      cb(0, null, '');
    }
  }
  function rootPath(p) { return String(C.root || '/').replace(/\/$/, '') + p; }
  function newId() {
    var a = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(a);
    var s = '';
    for (var k = 0; k < a.length; k++) s += String.fromCharCode(a[k]);
    return window.btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function wire(s) {
    return visible(s).map(function (x) { return [x[0], x[1], x[2]]; });
  }

  /* ---------- phase 1: sync with the worker, only for a list the visitor opted in ---------- */
  var timer = null;
  var busy = false;
  var again = false;
  var waiters = [];
  var onEnded = null; /* set by the wishlist page: the worker says this list is no longer kept there */

  function syncSoon() {
    if (!API) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { sync(); }, 900);
  }
  function sync(cb) {
    var s = load();
    if (cb) waiters.push(cb);
    if (!API || !s.on || !s.id) return done(s, 0);
    if (busy) { again = true; return; }
    busy = true;
    var sentRev = s.r;
    xhr('POST', API + '/v1/wish', { s: C.s, do: 'sync', id: s.id, rev: s.r, loc: C.loc, items: wire(s) }, function (st, j) {
      busy = false;
      var cur = load();
      var ended = false;
      if (st === 200 && j && j.ok) {
        if (!j.on) {
          /* stopped through the link in a mail, expired, or erased on request: back to a local list */
          ended = cur.on > 0;
          cur.on = 0; cur.id = null; cur.d = 0; cur.cap = 0;
        } else {
          cur.on = j.confirm ? 2 : 1;
          cur.cap = j.cap > 0 && j.n > j.cap ? Math.floor(j.cap) : 0;
          if (cur.r === sentRev) cur.d = 0;
        }
        save(cur);
      }
      /* no answer, 429 or 5xx: "d" stays 1 and the next page view or change tries again */
      done(cur, st);
      if (ended && onEnded) onEnded();
      if (again) { again = false; syncSoon(); }
    });
  }
  function done(s, status) {
    var list = waiters;
    waiters = [];
    list.forEach(function (f) { try { f(s, status); } catch (e) {} });
  }
  /* cb(error | null): error is 'invalid' | 'rate' | 'error' */
  function optIn(email, cb) {
    var s = load();
    if (!API) return cb('error');
    if (!s.id) {
      /* kept before the request goes out: a retry after a lost answer reuses the same list at the worker */
      s.id = newId();
      save(s);
    }
    var sentRev = s.r;
    xhr('POST', API + '/v1/wish', { s: C.s, do: 'on', id: s.id, email: email, tick: 1, cv: C.cv, loc: C.loc, rev: s.r, items: wire(s) }, function (st, j) {
      if (st === 200 && j && j.ok && j.on) {
        var cur = load();
        cur.id = s.id;
        cur.on = j.confirm ? 2 : 1;
        cur.cap = j.cap > 0 && j.n > j.cap ? Math.floor(j.cap) : 0;
        cur.d = cur.r === sentRev ? 0 : 1;
        save(cur);
        if (cur.d) syncSoon();
        return cb(null);
      }
      cb(st === 422 ? 'invalid' : st === 429 ? 'rate' : 'error');
    });
  }
  function optOut(cb) {
    var s = load();
    var forget = function () {
      var cur = load();
      cur.on = 0; cur.id = null; cur.d = 0; cur.cap = 0;
      save(cur);
      cb(null);
    };
    if (!API || !s.id) return forget();
    xhr('POST', API + '/v1/wish', { s: C.s, do: 'off', id: s.id }, function (st, j) {
      if (st === 200 && j && j.ok) return forget();
      cb(st === 429 ? 'rate' : 'error'); /* not confirmed by the worker: do not claim the address is gone */
    });
  }
  /* optional, off by default: one anonymous +1 / -1 per perfume. No list key, no address. */
  function tap(pid, handle, d) {
    if (API && C.taps) xhr('POST', API + '/v1/wish', { s: C.s, do: 'tap', p: pid, h: handle, d: d }, function () {});
  }

  /* ---------- hearts, counter, toast ---------- */
  function label(btn, s) {
    var k = at(s, btn.getAttribute('data-dg-wishlist'));
    var on = k >= 0 && !s.i[k][3];
    var title = btn.getAttribute('data-title');
    /* a button that shows a word (product page: "Bewaren" / "Bewaard") starts its name with that word, so the
       name a screen reader or voice control uses matches what is on screen (WCAG 2.5.3, qa4 a11y-03) */
    var word = btn.querySelector(on ? '.dg-wishlist-btn__text--on' : '.dg-wishlist-btn__text--off');
    word = word ? String(word.textContent || '').replace(/\s+/g, ' ').trim() : '';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', (word || (on ? T.remove : T.save)) + (title ? ': ' + title : ''));
  }
  function each(sel, fn, root) { Array.prototype.forEach.call((root || doc).querySelectorAll(sel), fn); }
  function paint(s) {
    if (C.paint) C.paint(s.i);
    var n = visible(s).length;
    each('[data-dg-wishlist]', function (b) { label(b, s); });
    each('[data-dg-wishlist-link]', function (a) {
      var base = a.getAttribute('data-label') || T.title || '';
      if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', n ? base + ' (' + n + ')' : base);
      var num = a.querySelector('[data-dg-wishlist-n]');
      if (num) { num.textContent = n > 99 ? '99+' : String(n); num.hidden = !n; }
    });
    listeners.forEach(function (f) { try { f(s); } catch (e) {} });
  }
  var listeners = [];

  var toastEl = null;
  var toastTimer = null;
  /* action: { text, href } or { text, fn } */
  function toast(text, action) {
    if (toastEl && toastEl.parentNode) toastEl.parentNode.removeChild(toastEl);
    window.clearTimeout(toastTimer);
    var el = doc.createElement('div');
    el.className = 'dg-wishlist-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    var span = doc.createElement('span');
    span.textContent = text;
    el.appendChild(span);
    if (action && action.text) {
      var a = doc.createElement(action.href ? 'a' : 'button');
      if (action.href) a.setAttribute('href', action.href);
      else {
        a.setAttribute('type', 'button');
        a.addEventListener('click', function () { hide(); action.fn(); });
      }
      a.textContent = action.text;
      el.appendChild(a);
    }
    function hide() {
      el.classList.remove('dg-wishlist-toast--in');
      window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); if (toastEl === el) toastEl = null; }, 250);
    }
    doc.body.appendChild(el);
    toastEl = el;
    (window.requestAnimationFrame || window.setTimeout)(function () { el.classList.add('dg-wishlist-toast--in'); });
    toastTimer = window.setTimeout(hide, action && action.fn ? 7000 : 4500);
  }

  function changed() {
    var s = load();
    if (s.on) syncSoon();
  }
  function restore(item) {
    var s = load();
    if (add(s, item[0], item[1], item[2]) === 'added') { save(s); changed(); tap(item[0], item[1], 1); }
  }
  /* a tap on a heart, anywhere on the site */
  function onHeart(btn) {
    var pid = String(btn.getAttribute('data-dg-wishlist') || '');
    var handle = String(btn.getAttribute('data-handle') || '').toLowerCase();
    var s = load();
    var k = at(s, pid);
    if (k >= 0 && !s.i[k][3]) {
      var item = drop(s, pid);
      save(s);
      changed();
      tap(pid, handle, -1);
      toast(T.toast_removed, { text: T.undo, fn: function () { restore(item); } });
      return;
    }
    var res = add(s, pid, handle, Date.now());
    if (res === 'full') return toast(fill(T.full, { n: MAX }));
    if (res !== 'added') return;
    save(s);
    changed();
    tap(pid, handle, 1);
    btn.classList.add('dg-wishlist-btn--pop');
    window.setTimeout(function () { btn.classList.remove('dg-wishlist-btn--pop'); }, 400);
    toast(T.toast_saved, onPage ? null : { text: T.view, href: C.page });
  }

  var onPage = false;
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-dg-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    onHeart(btn);
  });
  /* cards that arrive later (rails, search, filters) get their label the moment someone reaches them */
  ['pointerdown', 'focusin'].forEach(function (type) {
    doc.addEventListener(type, function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-dg-wishlist]') : null;
      if (btn) label(btn, load());
    }, true);
  });

  /* ---------- share link: /pages/wishlist#l=handle,handle  (the part behind # never leaves the browser) ---------- */
  function shareUrl(s) {
    var handles = visible(s).slice(0, SHARE_MAX).map(function (x) { return x[1]; });
    return window.location.origin + C.page + '#l=' + handles.join(',');
  }
  function parseShared(hash) {
    var m = /^#l=([a-z0-9_,-]{1,12000})$/.exec(String(hash || ''));
    if (!m) return null;
    var seen = {};
    var out = [];
    m[1].split(',').forEach(function (h) {
      if (HANDLE.test(h) && !seen[h] && out.length < SHARE_MAX) { seen[h] = 1; out.push(h); }
    });
    return out;
  }

  /* ---------- the wishlist page ---------- */
  function initPage(root) {
    if (root.getAttribute('data-dgw-ready')) return;
    root.setAttribute('data-dgw-ready', '1');
    onPage = true;

    var P = {};
    try { P = JSON.parse(root.querySelector('[data-dgw-strings]').textContent) || {}; } catch (e) { P = {}; }
    var q = function (sel) { return root.querySelector(sel); };
    var grid = q('[data-dgw-grid]');
    if (!grid) return;
    var countEl = q('[data-dgw-count]');
    var empty = q('[data-dgw-empty]');
    var tools = q('[data-dgw-tools]');
    var sharedBox = q('[data-dgw-shared]');
    var loading = q('[data-dgw-loading]');
    var where = q('[data-dgw-where]');
    var shared = parseShared(window.location.hash);
    var show = function (el, on) { if (el) el.hidden = !on; };
    var FAIL = root.getAttribute('data-t-fail') || 'This sample could not be loaded.';
    var RETRY = root.getAttribute('data-t-retry') || 'Try again';

    function cardCount() { return grid.querySelectorAll('[data-dg-wishlist-item]').length; }
    /* slots still waiting for their card (a slot that gave up shows "try again" and does not count) */
    function waiting() { return grid.querySelectorAll('[data-dgw-slot]:not(.dg-wishlist__item--fail)').length; }
    function settle() {
      var s = load();
      /* a shared list counts the cards plus the slots still on their way (the count line does not blink) */
      var n = shared ? grid.querySelectorAll('[data-dg-wishlist-item],[data-dgw-slot]').length : visible(s).length;
      var wait = waiting();
      if (countEl) countEl.textContent = n === 1 ? P.count_one : fill(P.count_many, { n: n });
      show(countEl, n > 0);
      /* the grey slots are the loading state; the text line stays for browsers without them (no JS = noscript) */
      show(loading, false);
      if (wait) grid.setAttribute('aria-busy', 'true'); else grid.removeAttribute('aria-busy');
      show(empty, n === 0 && wait === 0);
      show(tools, !shared && n > 0);
      show(sharedBox, !!shared);
      var saveAll = q('[data-dgw-save-all]');
      show(saveAll, !!shared && n > 0);
      if (where) where.textContent = s.on ? P.local_on : P.local;
      paintArrive();
    }

    /* The cards: Shopify renders them in the visitor's language (sections/dg-wishlist-card.liquid).
       Fix round 4 (15 Oct 2026): up to 20 cards per request through the search page (the handles ride in q),
       2 requests at a time, so 100 saved samples are 5 requests instead of 100. A perfume the batch does not
       return is asked for alone at /products/<handle>: that follows a renamed handle and gives a real 404 for a
       removed one (only a 404 hides it from the count). No answer, 429 or 5xx: tried again after 2 s and 4 s
       (or what Retry-After says); after that the slot says so and offers "try again". A card is never dropped
       without a word. */
    var BATCH = 20;
    var LANES = 2;
    var queue = [];
    var running = 0;
    function slotFor(key) {
      var li = doc.createElement('li');
      li.className = 'dg-wishlist__item dg-wishlist__item--wait';
      li.setAttribute('data-dgw-slot', key);
      return li;
    }
    function pump() {
      while (running < LANES && queue.length) {
        var jobs = [queue.shift()];
        if (!jobs[0].one) while (jobs.length < BATCH && queue.length && !queue[0].one) jobs.push(queue.shift());
        jobs = jobs.filter(function (job) { return job.slot.parentNode === grid; });
        if (jobs.length) run(jobs);
      }
    }
    function urlFor(jobs) {
      if (jobs.length === 1) return rootPath('/products/' + encodeURIComponent(jobs[0].handle)) + '?section_id=dg-wishlist-card';
      return rootPath('/search') + '?q=' + encodeURIComponent(jobs.map(function (job) { return job.handle; }).join(',')) +
        '&type=product&section_id=dg-wishlist-card';
    }
    function run(jobs) {
      running++;
      var one = jobs.length === 1;
      xhr('GET', urlFor(jobs), null, function (st, j, text, x) {
        running--;
        /* a 200 that is not our section (a bot check page, say) counts as no answer */
        var ours = st === 200 && /shopify-section-dg-wishlist-card/.test(text || '');
        if (ours || (one && st === 404)) {
          var byHandle = {};
          var byPid = {};
          if (st === 200 && text) {
            var box = doc.createElement('div');
            box.innerHTML = text;
            each('[data-dg-wishlist-item]', function (li) {
              byHandle[li.getAttribute('data-handle')] = li;
              byPid[li.getAttribute('data-dg-wishlist-item')] = li;
            }, box);
          }
          var alone = [];
          jobs.forEach(function (job) {
            var li = byHandle[job.handle] || (job.pid && byPid[job.pid]) || null;
            /* a single request answers with the product behind a renamed handle */
            if (!li && one) for (var k in byPid) { li = byPid[k]; break; }
            if (li) {
              delete byHandle[li.getAttribute('data-handle')];
              delete byPid[li.getAttribute('data-dg-wishlist-item')];
              return place(job, li, st);
            }
            if (!one) { job.one = true; alone.push(job); return; } /* not in the batch: ask for it alone */
            /* alone, 404 or our section without a card (Shopify answers 200 with an empty section for a product
               that does not exist, or is not sold in this market): not found. Hidden from the count, asked for
               again on the next visit (it may be back). */
            place(job, null, 404);
          });
          if (alone.length) queue = alone.concat(queue);
        } else {
          later(jobs, st, x);
        }
        settle();
        pump();
      });
    }
    function place(job, li, st) {
      var inList = !job.pid || at(load(), job.pid) >= 0; /* removed while the card was on its way */
      var match = !!li && (!job.pid || li.getAttribute('data-dg-wishlist-item') === job.pid);
      if (match && inList && job.slot.parentNode) {
        job.slot.parentNode.replaceChild(li, job.slot);
        if (job.pid) { gone(job.pid, 0); rename(job.pid, li.getAttribute('data-handle')); }
        each('[data-dg-wishlist]', function (b) { label(b, load()); }, li);
        return;
      }
      if (job.slot.parentNode) job.slot.parentNode.removeChild(job.slot);
      /* Only a clear "not found" (404, or the handle now belongs to another product) hides a perfume from the count. */
      if (job.pid && inList && (st === 404 || (!!li && !match))) gone(job.pid, 1);
    }
    function later(jobs, st, x) {
      var alive = jobs.filter(function (job) { job.tries = (job.tries || 0) + 1; return job.slot.parentNode === grid; });
      if (!alive.length) return;
      if (alive[0].tries >= 3) return alive.forEach(failed);
      var wait = 2000 * alive[0].tries;
      var ra = x && st === 429 ? parseInt(x.getResponseHeader('Retry-After') || '', 10) : NaN;
      if (ra > 0) wait = Math.min(30000, Math.max(wait, ra * 1000));
      window.setTimeout(function () {
        queue = alive.filter(function (job) { return job.slot.parentNode === grid; }).concat(queue);
        pump();
      }, wait);
    }
    function failed(job) {
      var li = job.slot;
      li.className = 'dg-wishlist__item dg-wishlist__item--wait dg-wishlist__item--fail';
      li.__job = job;
      li.innerHTML = '';
      var box = doc.createElement('div');
      box.className = 'dg-wishlist__fail';
      var p = doc.createElement('p');
      p.textContent = FAIL;
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'dg-wishlist__textbtn';
      b.setAttribute('data-dgw-retry', '');
      b.textContent = RETRY;
      box.appendChild(p);
      box.appendChild(b);
      li.appendChild(box);
      if (job.pid && !shared) {
        /* the visitor can still take it off the list */
        var rm = doc.createElement('button');
        rm.type = 'button';
        rm.className = 'dg-wishlist-btn dg-wishlist__remove';
        rm.setAttribute('data-dg-wishlist-remove', job.pid);
        rm.setAttribute('aria-label', T.remove || 'Remove');
        rm.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        var slot = doc.createElement('span');
        slot.className = 'dg-wishlist-slot';
        slot.appendChild(rm);
        li.appendChild(slot);
      }
    }
    function retryAll() {
      var again = [];
      each('.dg-wishlist__item--fail', function (li) {
        var job = li.__job;
        if (!job) return;
        li.className = 'dg-wishlist__item dg-wishlist__item--wait';
        li.innerHTML = '';
        job.tries = 0;
        job.one = false;
        again.push(job);
      }, grid);
      queue = again.concat(queue);
      settle();
      pump();
    }
    function gone(pid, flag) {
      var s = load();
      var k = at(s, pid);
      if (k < 0 || s.i[k][3] === flag) return;
      s.i[k][3] = flag;
      save(s); /* a display flag: no new revision, nothing to sync */
    }
    /* the shop renamed the handle (the old one redirects): keep the new one, so the next visit finds it in a batch */
    function rename(pid, handle) {
      handle = String(handle || '').toLowerCase();
      var s = load();
      var k = at(s, pid);
      if (k < 0 || !HANDLE.test(handle) || s.i[k][1] === handle) return;
      s.i[k][1] = handle;
      save(s); /* same perfume, same revision */
    }
    function want(pid, handle, before) {
      var slot = slotFor(pid || 'h:' + handle);
      if (before) grid.insertBefore(slot, before);
      else grid.appendChild(slot);
      queue.push({ pid: pid, handle: handle, slot: slot, tries: 0, one: false });
      return slot;
    }
    /* newest first; what was hidden as "not found" goes last (it may be back, and if not, only the end moves) */
    function order(s) {
      return s.i.slice().sort(function (a, b) { return (a[3] - b[3]) || (b[2] - a[2]); });
    }
    function build() {
      queue = [];
      /* the grey slots that the page drew before this script ran (sections/dg-wishlist.liquid) are replaced
         one for one by slots of the same size: nothing moves */
      grid.innerHTML = '';
      if (shared) shared.forEach(function (h) { want(null, h); });
      else order(load()).forEach(function (x) { want(x[0], x[1]); });
      settle();
      pump();
    }

    /* ----- own list: remove with undo, clear, share ----- */
    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var rm = t.closest('[data-dg-wishlist-remove]');
      if (rm && !shared) {
        e.preventDefault();
        var pid = String(rm.getAttribute('data-dg-wishlist-remove'));
        var li = rm.closest('[data-dg-wishlist-item],[data-dgw-slot]');
        var s = load();
        var item = drop(s, pid);
        if (!item) return;
        save(s);
        changed();
        tap(item[0], item[1], -1);
        var next = li ? li.nextElementSibling : null;
        if (li) {
          li.classList.add('dg-wishlist__item--out');
          window.setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); settle(); }, 200);
        }
        settle();
        toast(T.toast_removed, {
          text: T.undo,
          fn: function () {
            var cur = load();
            if (add(cur, item[0], item[1], item[2]) !== 'added') return;
            save(cur);
            changed();
            tap(item[0], item[1], 1);
            want(item[0], item[1], next && next.parentNode === grid ? next : null);
            settle();
            pump();
          },
        });
        return;
      }
      if (t.closest('[data-dgw-retry]')) return retryAll();
      if (t.closest('[data-dgw-clear]')) return clearList(t.closest('[data-dgw-clear]'));
      if (t.closest('[data-dgw-share]')) return share();
      if (t.closest('[data-dgw-save-all]')) return saveAll();
      if (t.closest('[data-dgw-arrive-off]')) return arriveOff(t.closest('[data-dgw-arrive-off]'));
    });

    var clearTimer = null;
    function clearList(btn) {
      if (!btn.getAttribute('data-armed')) {
        /* two steps instead of a browser dialog: the second tap within five seconds does it */
        btn.setAttribute('data-armed', '1');
        btn.textContent = P.clear_yes;
        clearTimer = window.setTimeout(function () { btn.removeAttribute('data-armed'); btn.textContent = P.clear; }, 5000);
        return;
      }
      window.clearTimeout(clearTimer);
      btn.removeAttribute('data-armed');
      btn.textContent = P.clear;
      var s = load();
      var old = visible(s);
      if (!s.i.length) return;
      s.i = [];
      touch(s);
      save(s);
      changed();
      old.forEach(function (x) { tap(x[0], x[1], -1); });
      queue = [];
      grid.innerHTML = '';
      settle();
      toast(P.cleared);
    }
    function share() {
      var s = load();
      var n = visible(s).length;
      if (!n) return;
      var url = shareUrl(s);
      var note = q('[data-dgw-share-note]');
      if (note) { note.textContent = fill(P.share_cut, { n: SHARE_MAX }); note.hidden = n <= SHARE_MAX; }
      var copy = function () {
        if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
          window.navigator.clipboard.writeText(url).then(function () { toast(P.share_copied); }, function () { window.prompt(P.share_prompt, url); });
        } else window.prompt(P.share_prompt, url);
      };
      if (window.navigator.share && window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
        window.navigator.share({ title: fill(P.share_msg, { shop: C.shop || 'DecantGems' }), url: url }).catch(function (err) {
          if (!err || err.name !== 'AbortError') copy();
        });
      } else copy();
    }
    function saveAll() {
      var s = load();
      var n = 0;
      var full = false;
      each('[data-dg-wishlist-item]', function (li) {
        var res = add(s, li.getAttribute('data-dg-wishlist-item'), li.getAttribute('data-handle'), Date.now() - n);
        if (res === 'added') { n++; tap(li.getAttribute('data-dg-wishlist-item'), li.getAttribute('data-handle'), 1); }
        if (res === 'full') full = true;
      }, grid);
      if (n) { save(s); changed(); }
      if (full && !n) return toast(fill(T.full, { n: MAX }));
      toast(n ? fill(P.shared_saved, { n: n }) : P.shared_none, { text: T.view, href: C.page });
    }

    /* ----- "Hear when they arrive" (phase 1 only) ----- */
    var arr = q('[data-dgw-arrive]');
    var form = q('[data-dgw-arrive-form]');
    var onBox = q('[data-dgw-arrive-on]');
    var statusEl = q('[data-dgw-arrive-status]');
    var capEl = q('[data-dgw-arrive-cap]');
    var errEl = q('[data-dgw-arrive-error]');
    var submit = q('[data-dgw-arrive-submit]');
    var tick = q('[data-dgw-arrive-tick]');
    var input = form ? form.querySelector('input[type="email"]') : null;

    function paintArrive() {
      if (!arr) return;
      var s = load();
      if (!API || shared || !form || !onBox) return show(arr, false);
      show(arr, visible(s).length > 0 || s.on > 0);
      show(form, !s.on);
      show(onBox, s.on > 0);
      if (statusEl && s.on) statusEl.textContent = s.on === 2 ? P.arr_confirm : P.arr_on;
      if (capEl) { capEl.textContent = fill(P.arr_cap, { n: s.cap }); capEl.hidden = !(s.on && s.cap); }
    }
    function arriveError(text) {
      if (!errEl) return;
      errEl.textContent = text || '';
      errEl.hidden = !text;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        arriveError('');
        var email = input ? String(input.value || '').trim() : '';
        if (!EMAIL.test(email) || email.length > 254) { arriveError(P.arr_invalid); if (input) input.focus(); return; }
        /* the box is never ticked for the visitor: without it nothing is sent */
        if (!tick || !tick.checked) { arriveError(P.arr_need_tick); if (tick) tick.focus(); return; }
        var text = submit ? submit.textContent : '';
        if (submit) { submit.disabled = true; submit.textContent = P.arr_wait || text; }
        optIn(email, function (err) {
          if (submit) { submit.disabled = false; submit.textContent = text; }
          if (err) return arriveError(err === 'invalid' ? P.arr_invalid : err === 'rate' ? P.arr_rate : P.arr_error);
          if (input) input.value = '';
          if (tick) tick.checked = false;
          settle();
        });
      });
    }
    function arriveOff(btn) {
      btn.disabled = true;
      optOut(function (err) {
        btn.disabled = false;
        if (err) return toast(err === 'rate' ? P.arr_rate : P.arr_error);
        settle();
        toast(P.arr_stopped);
      });
    }
    onEnded = function () { settle(); toast(P.arr_ended); };

    /* ----- start ----- */
    if (shared) {
      root.classList.add('dg-wishlist--shared');
      var eb = q('[data-dgw-eyebrow]');
      var hd = q('[data-dgw-heading]');
      if (eb) eb.textContent = P.shared_eyebrow;
      if (hd) hd.textContent = P.shared_heading;
      var et = q('[data-dgw-empty-title]');
      var ex = q('[data-dgw-empty-text]');
      if (et) et.textContent = P.shared_empty;
      if (ex) ex.hidden = true;
    }
    build();
    /* a synced list: tell the worker what is here and hear whether the list is still kept there */
    if (!shared && API && load().on) sync(function () { settle(); });
    /* the list changed in another tab */
    listeners.push(function () { if (!building) settle(); });
    /* only what changed is added or taken away; the cards already here stay (was: everything asked for again) */
    window.addEventListener('storage', function (e) {
      if (e.key !== KEY || shared) return;
      var now = load();
      building = true;
      paint(now);
      building = false;
      var have = {};
      each('[data-dg-wishlist-item],[data-dgw-slot]', function (li) {
        have[li.getAttribute('data-dg-wishlist-item') || li.getAttribute('data-dgw-slot')] = li;
      }, grid);
      var top = grid.firstElementChild;
      order(now).forEach(function (x) {
        if (!have[x[0]] && !x[3]) want(x[0], x[1], top); /* "not found" ones wait for the next visit */
        delete have[x[0]];
      });
      Object.keys(have).forEach(function (k) { var li = have[k]; if (li.parentNode) li.parentNode.removeChild(li); });
      settle();
      pump();
    });
    /* "my own list" on a shared link, or a new shared link pasted into this tab */
    window.addEventListener('hashchange', function () { window.location.reload(); });
  }
  var building = false;

  function start() {
    var s = load();
    paint(s);
    askConsent();
    each('[data-dg-wishlist-page]', initPage);
    /* a change that did not reach the worker last time */
    if (API && s.on && s.d && !onPage) syncSoon();
  }
  if (doc.readyState !== 'loading') start();
  else doc.addEventListener('DOMContentLoaded', start);
  window.addEventListener('pageshow', function (e) { if (e.persisted) paint(load()); });
  window.addEventListener('storage', function (e) { if (e.key === KEY && !onPage) paint(load()); });
  doc.addEventListener('shopify:section:load', function (e) {
    paint(load());
    if (e.target && e.target.querySelectorAll) each('[data-dg-wishlist-page]', initPage, e.target);
  });

  /* for the theme and for the tests */
  C.list = function () { return visible(load()).map(function (x) { return { id: x[0], handle: x[1], at: x[2] }; }); };
  C._ = { KEY: KEY, MAX: MAX, SHARE_MAX: SHARE_MAX, load: load, save: save, add: add, drop: drop, visible: visible, sync: sync, optIn: optIn, optOut: optOut, shareUrl: shareUrl, parseShared: parseShared, onHeart: onHeart, clean: clean };
})();
